module.exports = __webpack_public_path__ + "img/prizeListTitle.9477a196.png";